<template>
  <BasePage :pageTitle="resort ? `${resort} POIs` : __DICT__.passengerView.resort" show-menu back-button show-footer>
    <!-- Filter Select -->
    <Card :title="__DICT__.filterByType" margin="mb-3">
      <template #header>
        <div class="d-flex align-items-center">
          <h3 class="card-title me-3">{{ __DICT__.filterByType }}</h3>
          <Select v-model="selectedTag" :options="uniqueTags" custom-class="w-auto" />
        </div>
      </template>
    </Card>

    <!-- POIs List -->
    <Card margin="" body-class="p-0">
      <div class="table-responsive">
        <table class="table table-vcenter card-table">
          <thead>
          <tr>
            <th>{{ __DICT__.name }}</th>
            <th>{{ __DICT__.type }}</th>
            <th>{{ __DICT__.location }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="poi in filteredPois" :key="poi.id">
            <td>{{ poi.name }}</td>
            <td>
              <span class="badge bg-primary text-white">{{ poi.tagName }}</span>
            </td>
            <td>
              <a
                  :href="poi.lat != null && poi.lon != null ? `https://maps.google.com/?q=${poi.lat},${poi.lon}` : '#'"
                  target="_blank"
                  class="btn btn-icon btn-ghost-primary"
                  title="Open in Google Maps"
              >
                <IconMapPin class="icon" :size="24" />
              </a>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </Card>
  </BasePage>
</template>

<script setup>
import { useWeekStore } from "@/stores/week.js";
import BasePage from "@/components/BasePage.vue";
import { useRouter, useRoute } from "vue-router";
import { api } from "@/services/api.js";
import { ref, computed, onMounted } from "vue";
import { Card, Select } from "@/components/atomic";
import { IconMapPin } from '@tabler/icons-vue';

const router = useRouter();
const route = useRoute();
const pois = ref([]);
const resort = ref(null);
const selectedTag = ref('All');

const fetchPois = async () => {
  try {
    const resortId = route.params.resortId;
    const response = await api.get(`/api/resort/${resortId}`);
    pois.value = response.filter(poi =>
        poi.brandSlug === 'all' || poi.brandSlug === __DICT__.brand
    ).sort((a, b) => a.position - b.position);

    if (pois.value.length > 0) {
      resort.value = pois.value[0].resortName;
    }
  } catch (error) {
    console.error('Failed to fetch POIs:', error);
  }
};

const uniqueTags = computed(() => {
  const tags = new Set(pois.value.map(poi => poi.tagName));
  return ['All', ...Array.from(tags).sort()];
});

const filteredPois = computed(() => {
  if (selectedTag.value === 'All') {
    return pois.value;
  }
  return pois.value.filter(poi => poi.tagName === selectedTag.value);
});

onMounted(() => {
  fetchPois();
});
</script>